import styled, { css } from 'styled-components';
import {
  boldHeadLine4,
  galleryImages,
  headLine2,
  headLine3,
  headLine4,
  headLine5,
  linkText,
  para1,
  readmoreText,
} from '../theme/GlobalStyle';

export const NewsDetailContainer = styled.div`
  width: 100%;
  padding: 7% 0;
  display: flex;
  justify-content: space-between;

  @media (max-width: 995px) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    padding: 10% 0 6%;
    h4 {
      margin: 0;
    }
  }
`;
export const MainNewsContainer = styled.div`
  padding-bottom: 10px;
  width: 73%;
  z-index: 1;
  .post-image {
    margin: 30px 0;
    img {
      border: 1px solid rgba(0, 0, 0, 20%);
    }
  }
  .content {
    h1,
    h2,
    h3 {
      ${headLine3}
    }
    h4 {
      ${headLine4}
    }
    h5,
    h6 {
      ${headLine5}
    }
    span a img {
      width: 18px;
      display: inline;
      vertical-align: middle;
    }
    p .alignleft {
      float: left;
      margin: 0 15px 0 0;
      width: 300px;
      height: 169px;
    }
    p .alignright {
      float: right;
      margin: 0 0 0 15px;
      width: 300px;
      height: 169px;
    }
    li {
      margin: 10px 0;
    }
    p .alignleft {
      float: left;
      margin: 0 15px 0 0;
      width: 300px;
      height: 169px;
    }
    p .alignright {
      float: right;
      margin: 0 0 0 15px;
      width: 300px;
      height: 169px;
    }
    p iframe {
      width: 100%;
    }
    ul,
    ol {
      margin: 20px 0 20px 5px;
      padding-left: 15px;
    }
    ul,
    ol,
    p {
      ${para1}
      color: ${(props) => props.theme.color.textLight};
    }
    ul {
      list-style-type: disc;
      strong,
      b {
        ${boldHeadLine4}
      }
    }
    .grid-images {
      display: flex;
      flex-wrap: wrap;
      gap: 30px;

      & img {
        width: 22%;
        object-fit: contain;
      }

      @media (max-width: 1210px) {
        & img {
          width: 30%;
        }
      }

      @media (max-width: 768px) {
        & img {
          width: 44%;
        }
      }
    }

    p {
      margin: 15px 0;
      ${para1}
      color: ${(props) => props.theme.color.textLight};

      strong,
      b {
        ${boldHeadLine4}
      }
    }
    a {
      color: ${(props) => props.theme.color.primary};
      ${para1}
      text-decoration: underline;
    }
    a.blue {
      color: ${(props) => props.theme.color.primary};
      ${para1}
      text-decoration: underline;
    }
    a.white {
      color: ${(props) => props.theme.color.white};
      ${para1}
      text-decoration: underline;
    }
    video {
      width: 100%;
      height: auto;
    }
    .wp-video {
      width: 100% !important;
    }

    table {
      text-align: center;
      td {
        vertical-align: top;
        padding: 10px;
        strong,
        b {
          ${boldHeadLine4}
        }
      }
    }
    blockquote {
      padding: 30px 50px;
      margin: 15px 0;
      background-color: ${(props) => props.theme.color.bgPrimary};
      color: ${(props) => props.theme.color.white};
      p {
        color: ${(props) => props.theme.color.white};
        ${para1}
      }
      a {
        color: ${(props) => props.theme.color.white};
        ${para1}
        transition: text-decoration ease-in-out 0.2s;

        @media (min-width: 1024px) {
          &:hover {
            text-decoration: underline;
          }
        }
      }
      span {
        position: relative;
        color: ${(props) => props.theme.color.white};
        ${para1}
        &:before {
          content: '"';
          position: absolute;
          left: -20px;
          font-size: 40px;
        }
        &:after {
          content: '"';
          position: absolute;
          right: -20px;
          font-size: 40px;
        }
      }
    }
    .inline-twitter-link,
    .bctt-ctt-text a {
      color: #333333;
      background-color: #d9ecfd;
      text-decoration: none;
      transition: all ease-in-out 0.2s;

      @media (min-width: 1024px) {
        &:hover {
          background-color: #337ab7;
          color: #fff;
          text-decoration: underline;
        }
      }
    }
    @media (max-width: 995px) {
      blockquote {
        padding: 25px 50px;
      }
    }
    ${galleryImages}
  }
  .post-accordion-content {
    padding-bottom: 20px;
  }
  .accordion-section {
    padding: 20px 0;
  }
  .register-link-event {
    display: flex;
    gap: 10px;
  }
  @media (max-width: 995px) {
    width: 100%;
  }

  .linkBtn {
    padding: 12px 20px;
    border: 1px solid transparent;
    border-radius: 6px;
    display: inline-block;
    background-color: ${(props) => props.theme.color.bgPrimary};
    color: ${(props) => props.theme.color.white};
    ${readmoreText}
    text-transform: capitalize;
    transition: all ease-in-out 0.2s;
    @media (min-width: 1024px) {
      &:hover {
        border: 1px solid ${(props) => props.theme.color.bgPrimary};
        background-color: ${(props) => props.theme.color.white};
        color: ${(props) => props.theme.color.bgPrimary};
      }
    }
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const RelatedPostContainer = styled.div`
  padding-bottom: 7%;
  &.mobile-view {
    display: none;
  }
  @media (max-width: 995px) {
    &.desktop-view {
      display: none;
    }
    &.mobile-view {
      padding-bottom: 0;
      display: block;
      order: 2;
    }
  }
`;

export const TrendingNewsContainer = styled.div`
  width: 25%;
  .category-btn-grp {
    padding: 4% 8%;
    margin: 45px 0;
    background-color: ${(props) => props.theme.color.bgSecondary};
  }
  .trending-section {
    padding: 20px 8%;
    background-color: ${(props) => props.theme.color.bgSecondary};
  }
  .event-section {
    margin: 20px 0;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    .category-btn-grp {
      padding: 0;
      margin: 0 0 20px;
    }
  }
  @media (max-width: 995px) {
    width: 100%;
    order: 3;
    .category-btn-grp {
      padding: 4%;
    }
    .trending-section {
      padding: 20px 4%;
    }
  }
`;

export const PageHeading = styled.h1`
  ${headLine2}
`;

export const NewsHeadingContent = styled.p`
  margin: 20px 0;
  color: ${(props) => props.theme.color.textLight};
  ${para1}
`;

export const NewsContent = styled(NewsHeadingContent)`
  padding: 8px 0;
  margin: 8px 0;
`;
export const ContentHeading = styled.h2`
  padding-left: 20px;
  border-left: 8px solid ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.primary};
  font-weight: bold;
  font-style: italic;
`;

export const SignUp = styled.div`
  padding: 14% 10%;
  background-color: ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.white};
  a {
    width: 92%;
    padding: 13px 0;
    border: 1px solid ${(props) => props.theme.color.white};
    border-radius: 4px;
    display: inline-block;
    background-color: ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.color.bgPrimary};
    ${readmoreText}
    text-transform: capitalize;
    transition: background-color ease-in-out 0.2s, color ease-in-out 0.2s;
    @media (min-width: 1024px) {
      &:hover {
        background-color: ${(props) => props.theme.color.bgPrimary};
        color: ${(props) => props.theme.color.white};
      }
    }
  }
  text-align: center;
  @media (max-width: 995px) {
    display: none;
    margin-top: 20px;
    padding: 12% 8%;
    button {
      width: 60%;
    }
  }
  @media (max-width: 768px) {
    order: 3;
  }
  @media (max-width: 576px) {
    button {
      width: 80%;
    }
  }
`;

export const SignUpTitle = styled.span`
  margin-bottom: 15px;
  display: block;
  ${headLine2}
`;

export const AuthorTime = styled.ul`
  margin: 10px 0 0;
  display: flex;
  flex-direction: column;
  ${linkText}
  color: ${(props) => props.theme.color.textLight};
  text-transform: ${({ capitalFlag }) => capitalFlag};
  li {
    margin: 5px 0;
  }
  .event-info {
    span:first-child,
    .event-time {
      margin-right: 5px;
      color: #173f87;
    }
    span:last-child,
    .event-time {
      margin-left: 5px;
    }
    .divider {
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 100%;
      margin: 0 8px 2px 6px;
      background-color: ${(props) => props.theme.color.textLight};
    }
  }
  li span.auth-span {
    padding-right: 8px;
    position: relative;
  }

  li span.auth-divider {
    &:before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 100%;
      margin: 0 8px;
      background-color: ${(props) => props.theme.color.textLight};
      vertical-align: middle;
    }
  }
  ul.author-list {
    display: flex;
    flex-wrap: wrap;
    li {
      padding-right: 5px;
    }
  }
  a {
    color: ${(props) => props.theme.color.primary};

    @media (min-width: 1024px) {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const NewsSocial = styled.ul`
  padding: 0;
  margin: 10px 0 0;
  display: flex;
  align-items: center;
  li {
    margin-right: 12px;
    list-style-type: none;
    &:last-child {
      margin-right: 0;
    }
    span {
      ${headLine5};
      color: ${(props) => props.theme.color.primary};
    }
    a {
      display: flex;
      align-items: center;
      color: ${(props) => props.theme.color.primary};
      font-size: 18px;

      button {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      svg {
        font-size: 16px;
      }
    }
  }
  li.facebook a {
    font-size: 16px;
  }
`;
export const VideoContainer = styled.div`
  width: 100%;
  height: 373px;
  position: relative;
  background-color: ${(props) => props.theme.color.bgLight};
`;
export const Video = styled.video`
  width: 100%;
`;
export const VideoButton = styled.button`
  width: 106px;
  height: 106px;
  border: 1px solid ${(props) => props.theme.color.primary};
  border-radius: 50%;
  outline: none;
  margin: 10px 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${(props) => props.theme.color.primary};
  font-size: 10px;
  cursor: pointer;
  transition: all 0.4s ease;

  @media (min-width: 1024px) {
    &:hover {
      background-color: ${(props) => props.theme.color.white};
      color: ${(props) => props.theme.color.primary};
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    }
  }
`;
export const ListContentHeading = styled.h3`
  padding: 25px 0;
  color: ${(props) => props.theme.color.primary};
  font-size: 22px;
  font-weight: bold;
`;
export const ListContentContainer = styled.ul`
  position: relative;
  @media (max-width: 573px) {
    margin-top: 30px;
  }
  li {
    padding: 0 0 27px 25px;
    position: relative;
    color: ${(props) => props.theme.color.primary};
    list-style-type: none;
    ${para1}
    &:before {
      content: '';
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: ${(props) => props.theme.color.primary};
      position: absolute;
      top: 5%;
      left: 0;
    }
  }
`;
export const ImageGrid = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ secondary }) =>
    secondary &&
    css`
    column
  `};
  .image-grid-one {
    ${({ secondary }) =>
      secondary
        ? css`
            flex-basis: 100%;
          `
        : css`
            flex-basis: 49%;
          `}
  }
  .image-grid-two {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-basis: 49%;
    ${({ secondary }) =>
      secondary &&
      css`
        margin-bottom: 2%;
        flex-direction: row;
      `}
    .image-one {
      flex-basis: 49%;
    }
    .image-two {
      flex-basis: 49%;
    }
  }
  figure {
    width: 100%;
  }
`;
export const Categoris = styled.div`
  span {
    margin: 10px 0;
    display: block;
    ${headLine3}
  }
`;

export const TagButtonGroup = styled.ul`
  display: flex;
  flex-wrap: wrap;
  color: ${(props) => props.theme.color.bgPrimary};
  li {
    margin-right: 10px;
    a {
      display: block;
      padding: 6px 8px;
      border: 1px solid ${(props) => props.theme.color.bgPrimary};
      border-radius: 6px;
      margin: 5px 0;
      outline: none;
      background-color: transparent;
      color: ${(props) => props.theme.color.bgPrimary};
      ${readmoreText}
      transition: all 0.2s ease;
      ${({ secondary }) =>
        secondary &&
        css`
          padding: 8px 10px;
          border: 1px solid ${(props) => props.theme.color.bgPrimary};
          ${linkText}
        `}
      @media (min-width: 1024px) {
        &:hover {
          background-color: ${(props) => props.theme.color.bgPrimary};
          color: ${(props) => props.theme.color.white};
        }
      }
    }
  }
`;

export const PostContainer = styled.div`
  width: 100%;
  padding-top: 20px;
  h4 {
    margin: 18px 0;
    ${headLine3}
  }
  .related-post {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .post {
      flex-basis: 49%;
    }
  }
  @media (max-width: 768px) {
    .related-post {
      flex-direction: column;
    }
    .related-post li.post {
      flex-basis: 75%;
      margin: 20px auto;
    }
    .related-post li ul li {
      margin: 0;
    }
    h4 {
      margin: 10px 0;
    }
  }
  @media (max-width: 573px) {
    padding: 10px 0;
  }
`;

export const TrendingNewsHeading = styled.h5`
  margin: 10px 0;
  color: ${(props) => props.theme.color.textLight};
  ${headLine3}
  text-transform: capitalize;
`;

export const TagButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const TrendingNews = styled.ul`
  @media (max-width: 995px) {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    li {
      flex-basis: calc(50% - 10px);
      margin: 0 20px 0 0;

      &:nth-of-type(2n) {
        margin: 0;
      }
    }
    @media (max-width: 576px) {
      li {
        flex-basis: 100%;
        margin: 0;
      }
    }
  }
`;

export const HyperlinkCategories = styled.ul`
  margin: 3px 0;
  display: inline;
  .link-item {
    display: inline;
    margin: 2px 10px 0 0;
  }
  .divider {
    display: inline-block;
    width: 1px;
    height: 14px;
    margin: 0 10px 0 0;
    border-radius: 100%;
    background-color: ${(props) => props.theme.color.textLight};
    vertical-align: middle;
  }
  a {
    display: inline;
    ${linkText}
    color: ${(props) => props.theme.color.textLight};
    transition: text-decoration ease-in-out 0.2s, color ease-in-out 0.2s;
  }
  a.active {
    color: ${(props) => props.theme.color.primary};
    text-decoration: underline;
  }

  @media (min-width: 1024px) {
    a:hover {
      color: ${(props) => props.theme.color.primary};
      text-decoration: underline;
    }
  }
`;
